// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HUHq","comment":"styles_comment__3SgFL"};